module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listeningMsg":"I am listening..."},"es":{"listeningMsg":"Estoy escuchando..."}}')
  delete Component.options._Ctor
}
